import * as z from "zod";

export const RegisterFormSchema = z
  .object({
    email: z.string().email({ message: "errors.invalidEmail" }),
    password: z
      .string()
      .min(6, { message: "errors.passwordMin" })
      .regex(/[A-Z]/, { message: "errors.passwordUppercase" })
      .regex(/[0-9]/, { message: "errors.passwordNumber" })
      .regex(/[^A-Za-z0-9]/, { message: "errors.passwordSpecial" }),
    firstName: z.string().min(1, { message: "errors.firstNameRequired" }),
    lastName: z.string().min(1, { message: "errors.lastNameRequired" }),
    repeatPassword: z.string(),
  })
  .refine((data) => data.password === data.repeatPassword, {
    message: "errors.passwordsDontMatch",
    path: ["repeatPassword"],
  });
